import type { PropType } from 'vue';
import BaseState, { type IParams, type ITitleClass } from './base';
import CornerMark from './corner-mark.vue';
import type { IEquity } from '~/api/interface';

/** 个人体验版 */
export default class Rights1 extends BaseState {
  TitleView = defineComponent({
    name: 'TitleView1',
    props: {
      titleClass: {
        type: Object as PropType<ITitleClass>,
        required: true,
      },
      rights: {
        type: Object as PropType<IEquity>,
        required: true,
      },
      hovered: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    setup(props) {
      const { rights } = props;
      const { $t } = useNuxtApp();
      return () => (
        <>
          <div>
            <div class="title-name">{rights.rights_name}</div>
          </div>
          <div class="sub-title">{rights.subject}</div>
          {isChinese() ? <CornerMark text={$t('bu-ke-shang-yong')} /> : null}
        </>
      );
    },
  });

  PriceView = defineComponent({
    setup() {
      const { $t } = useNuxtApp();

      return () => (
        <div class={!isChinese() ? 'pt-[43px] pb-[16px]' : 'pt-[38px] pb-[34px]'}>
          <div class="text-left">
            {!isChinese() ? (
              <div>
                <div>
                  <span class="price-prefix text-[#0057D8]">{formatPrice(0).prefix}</span>
                  <span class="price-num text-[#0057D8]">{formatPrice(0).value}</span>
                </div>
              </div>
            ) : (
              <div class="text-[28px] leading-[36px] text-[#121926] font-bold">
                {$t('mian-fei')}
              </div>
            )}
          </div>
        </div>
      );
    },
  });

  get ButtonView() {
    const { $t } = useNuxtApp();

    if (this.isUserLogin) {
      return this.getButton({
        text: $t('yi-jing-shen-qing-ti-yan'),
        disabled: true,
      });
    }
    return this.getButton({
      text: $t('li-ji-ding-yue'),
      cb: this.toLogin,
    });
  }

  get StickyButtonView() {
    const { $t } = useNuxtApp();

    if (this.isUserLogin) {
      return this.getButton({
        text: $t('yi-jing-shen-qing-ti-yan'),
        disabled: true,
      });
    }
    return this.getButton({
      text: $t('li-ji-ding-yue'),
      cb: this.toLogin,
    });
  }
}
